import Box from '@mui/material/Box';

import styles from './styles';
import { Props } from './utils';

export default function ProgressBar({ progress = 0 }: Props) {
  return (
    <Box sx={styles.wrapper}>
      <Box sx={{ ...styles.progress, width: `${progress}%` }}></Box>
    </Box>
  );
}
